import { render, staticRenderFns } from "./solicitar_servico.vue?vue&type=template&id=6b13344d&scoped=true&"
import script from "./solicitar_servico.vue?vue&type=script&lang=js&"
export * from "./solicitar_servico.vue?vue&type=script&lang=js&"
import style0 from "./solicitar_servico.vue?vue&type=style&index=0&id=6b13344d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13344d",
  null
  
)

export default component.exports